// Swiper -----------------------------------------------------------
import Swiper, * as Carousel from 'swiper';
window.Swiper = Swiper;
window.Carousel = Carousel;



// SOLUTION CAROUSEL
// ------------------------------------------------------------------
if ($('.solution-carousel').length) {
    var solutionCarousel = new Swiper(".solution-carousel", {
        slidesPerView: 2.5,
        speed: 1000,
        spaceBetween: 40,
        loop: false,
        centeredSlides: true,
        modules: [Carousel.Navigation, Carousel.Pagination, Carousel.Autoplay, Carousel.EffectCreative],
        autoplay: {
            delay: 6000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".solution-next",
            prevEl: ".solution-prev"
        },
        pagination: {
            el: ".solution-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            600: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            769: {
                slidesPerView: 2,
            },
            900: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 2,
            },
            1201: {
                slidesPerView: 2.5,
            },
        },
    })
    let solutionCarouselCount = $('.solution-field .swiper-slide:not(.swiper-slide-duplicate)')
    let solutionCarouselTotalField = $('.solution-field .carousel-count-field .total')
    let solutionCarouselCurrentField = $('.solution-field .carousel-count-field .current')
    solutionCarouselTotalField.text(solutionCarouselCount.length)
    solutionCarouselCurrentField.text(1)
    let solutionCarouselLine = $('.solution-field .container .wrapper .carousel-field .carousel-controller .content .carousel-navigation-field .solution-navigation .solution-line')
    solutionCarouselLine.find('#color-field').addClass('active')
    solutionCarousel.on('slideChange', function () {
        solutionCarouselCurrentField.text(solutionCarousel.realIndex + 1)
        solutionCarouselLine.find('#color-field').removeClass('active')
        setTimeout(() => {
            solutionCarouselLine.find('#color-field').addClass('active')
        }, 10);
    })
}
// PRODUCT CAROUSEL
// ------------------------------------------------------------------
if ($('.product-carousel').length) {
    var productCarousel = new Swiper(".product-carousel", {
        slidesPerView: 1,
        speed: 1000,
        spaceBetween: 30,
        loop: false,
        modules: [Carousel.Navigation, Carousel.Autoplay],
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".product-next",
            prevEl: ".product-prev"
        },
    })
}
// HOMEPAGE CAROUSEL
// ------------------------------------------------------------------
if ($('.homepage-carousel').length) {
    var homepageCarousel = new Swiper(".homepage-carousel", {
        slidesPerView: 1,
        speed: 1000,
        spaceBetween: 30,
        loop: false,
        modules: [Carousel.Autoplay, Carousel.Pagination, Carousel.EffectCreative],
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        pagination: {
            el: ".homepage-pagination",
            clickable: true,
        },
        effect: 'creative',
        creativeEffect: {
            prev: {
                scale: 1.5,
                opacity: 0,
                shadow: true,
            },
            next: {
                scale: 1.5,
                opacity: 0,
                shadow: true,
            },
        },
    })
}

// GALLERY CAROUSEL
// ------------------------------------------------------------
if ($('.gallery-carousel').length) {
    var galleryCarousel = new Swiper(".gallery-carousel", {
        slidesPerView: 2.5,
        speed: 1000,
        spaceBetween: 30,
        loop: true,
        modules: [Carousel.Navigation, Carousel.Pagination, Carousel.Autoplay],
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".gallery-next",
            prevEl: ".gallery-prev"
        },
        pagination: {
            el: ".gallery-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            600: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            769: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 2,
            },
            1201: {
                slidesPerView: 2.5,
            },
        },
    })
    let totalCountField = $('.gallery-carousel .total-count-field')
    let total = $('.gallery-carousel .swiper-slide:not(.swiper-slide-duplicate)').length;
    totalCountField.find('.current').text(galleryCarousel.realIndex + 1)
    totalCountField.find('.total').text(total)
    galleryCarousel.on('slideChange', function () {
        totalCountField.find('.current').text(galleryCarousel.realIndex + 1)
    })
}

// HOMEPAGE - PRODUCT CAROUSEL
// ------------------------------------------------------------------
if ($('.homepage-product-carousel').length) {
    var homepageProductCarousel = new Swiper(".homepage-product-carousel", {
        slidesPerView: 5,
        speed: 1000,
        spaceBetween: 0,
        loop: true,
        direction: 'vertical',
        modules: [Carousel.Navigation, Carousel.Autoplay],
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        mousewheel: true,
        navigation: {
            nextEl: ".homepage-product-next",
            prevEl: ".homepage-product-prev"
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
            },
            425: {
                slidesPerView: 3,
            },
            600: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 2,
            },
            769: {
                slidesPerView: 3,
            },
            900: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            },
            1201: {
                slidesPerView: 5,
            },
        },
    })
}

// HOMEPAGE - PC CAROUSEL
// ------------------------------------------------------------------
if ($('.homepage-pc-carousel').length) {
    var homepagePCCarousel = new Swiper(".homepage-pc-carousel", {
        slidesPerView: 4,
        speed: 1000,
        spaceBetween: 0,
        loop: true,
        direction: 'vertical',
        slideToClickedSlide: true,
        modules: [Carousel.Navigation, Carousel.Autoplay],
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        mousewheel: true,
        navigation: {
            nextEl: ".homepage-pc-next",
            prevEl: ".homepage-pc-prev"
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                direction: 'horizontal',
            },
            600: {
                slidesPerView: 1,
                direction: 'horizontal',
            },
            768: {
                slidesPerView: 2,
                direction: 'horizontal',
            },
            769: {
                slidesPerView: 2,
                direction: 'horizontal',
            },
            900: {
                slidesPerView: 3,
                direction: 'horizontal',
            },
            1200: {
                slidesPerView: 3,
            },
            1201: {
                slidesPerView: 4,
            },
        },
    })
    let productBoxed = $('.homepage-product-field .container .wrapper .right-field .product-box-field')
    let productBoxedID
    if (windowWidth > 900) {
        productBoxed.height(productBoxed.find('.product-boxes.active').height() + 120)
    } else {
        productBoxed.height(productBoxed.find('.product-boxes.active').height())
    }
    homepagePCCarousel.on('slideChange', function () {
        productBoxed.find('.product-boxes').removeClass('active')
        $.each(productBoxed.find('.product-boxes'), function () {
            productBoxedID = $(this).attr('data-id')
            if (productBoxedID == homepagePCCarousel.realIndex + 1) {
                $(this).addClass('active')
                if (windowWidth > 900) {
                    productBoxed.height($(this).height() + 120)
                } else {
                    productBoxed.height($(this).height())
                }
            }
        })
    })
}

// YOUR PC CAROUSEL - STEP 1
// ------------------------------------------------------------------
if ($('.your-pc-carousel').length) {
    var yourPCCarousel = new Swiper(".your-pc-carousel", {
        slidesPerView: 3,
        speed: 1000,
        spaceBetween: 0,
        loop: false,
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            600: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            769: {
                slidesPerView: 2,
            },
            900: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            },
            1201: {
                slidesPerView: 3,
            },
        },
    })
    let stepOneIMG = $('.your-pc-content--one .container .wrapper .image-field')
    let yourPCStepOneSlide = $('.your-pc-content--one .container .wrapper .carousel-field .your-pc-carousel .swiper-wrapper .swiper-slide')
    let hoverTimeOut
    yourPCCarousel.on('slideChange', function () {
        $.each(yourPCStepOneSlide, function () {

            let image = $(this).attr('data-image');
            stepOneIMG.find('.img').addClass('active')

            clearTimeout(hoverTimeOut)
            hoverTimeOut = setTimeout(() => {
                stepOneIMG.find('img').attr('src', image)

                let loadedImage = document.createElement('img')
                loadedImage.src = image

                loadedImage.onload = function () {
                    stepOneIMG.find('.img').removeClass('active')
                }
            }, 450)
        })
    })
}


// SAMPLE CAROUSEL
// ------------------------------------------------------------------
/* if ($('.category-carousel').length) {
    var categoryCarousel = new Swiper(".category-carousel", {
        slidesPerView: 4,
        speed: 1000,
        spaceBetween: 0,
        loop: false,
        modules: [Carousel.Navigation, Carousel.Pagination, Carousel.Autoplay, Carousel.EffectCreative],
        effect: 'creative',
        creativeEffect: {
            prev: {
                scale: 1.5,
                opacity: 0,
                shadow: true,
            },
            next: {
                scale: 1.5,
                opacity: 0,
                shadow: true,
            },
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        navigation: {
            nextEl: ".category-next",
            prevEl: ".category-prev"
        },
        pagination: {
            el: ".category-pagination",
            clickable: true,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            600: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            769: {
                slidesPerView: 2,
            },
            900: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 3,
            },
            1201: {
                slidesPerView: 4,
            },
        },
    })
} */